import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import { Message, MessageBox } from 'element-ui';
import util from '@/libs/util.js';
import router from '@/router';
import { SYS_USER_LOGIN } from '@/api/sys.user.js';
export default {
  namespaced: true,
  actions: {
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref) {
      var _arguments = arguments;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var dispatch, params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch = _ref.dispatch;
                params = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {};
                return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve) {
                    var res;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return SYS_USER_LOGIN(params);

                          case 2:
                            res = _context.sent;
                            console.log('login res', res); // console.log('errorCount',res.data.errorCount);

                            if (!(res.code === 0)) {
                              _context.next = 16;
                              break;
                            }

                            if (!res.data.errorCount) {
                              _context.next = 9;
                              break;
                            }

                            resolve({
                              errorCount: res.data.errorCount,
                              msg: res.data.msg
                            });
                            _context.next = 16;
                            break;

                          case 9:
                            util.cookies.set('token', res.data.Token);
                            util.setUserInfo(res.data.Userinfo);
                            util.setVENDOR_CODE(res.data.Userinfo.VENDOR_CODE ? res.data.Userinfo.VENDOR_CODE : '');
                            util.setPARENT_VENDOR_CODE(res.data.Userinfo.PARENT_VENDOR_CODE ? res.data.Userinfo.PARENT_VENDOR_CODE : ''); // util.cookies.set('ORG_CODE', res.data.Userinfo.ORG_CODE)

                            _context.next = 15;
                            return dispatch('d2admin/user/set', res.data.Userinfo, {
                              root: true
                            });

                          case 15:
                            // const accessRoutes = await store.dispatch('d2admin/user/generateRoutes',store.getters.roleId)
                            // await store.dispatch('custom/permission/getBtnList')
                            // const sRoute = serializationRoutesData(accessRoutes)
                            // store.dispatch('d2admin/router/setRouters',sRoute)
                            // store.commit('d2admin/menu/asideSet',sRoute)
                            resolve(true);

                          case 16:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref2.apply(this, arguments);
                  };
                }()));

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout: function logout(_ref3) {
      var commit = _ref3.commit,
          dispatch = _ref3.dispatch;

      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$confirm = _ref4.confirm,
          confirm = _ref4$confirm === void 0 ? false : _ref4$confirm;

      /**
       * @description 注销
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认


      function _logout() {
        _logout = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  // 删除cookie
                  util.cookies.remove('token');
                  util.cookies.remove('userInfo');
                  util.cookies.remove('ORG_ID');
                  util.cookies.remove('ORG_CODE');
                  util.cookies.remove('srm-VENDOR_CODE');
                  util.cookies.remove('srm-businessAPI'); // util.cookies.remove('uuid')
                  // 清空 vuex 用户信息

                  _context3.next = 8;
                  return dispatch('d2admin/user/set', {}, {
                    root: true
                  });

                case 8:
                  _context3.next = 10;
                  return dispatch('d2admin/page/closeAll', {}, {
                    root: true
                  });

                case 10:
                  _context3.next = 12;
                  return dispatch('d2admin/router/setRouters', [], {
                    root: true
                  });

                case 12:
                  _context3.next = 14;
                  return commit('d2admin/menu/asideSet', [], {
                    root: true
                  });

                case 14:
                  // 跳转路由
                  router.push({
                    name: 'login'
                  });
                  window.location.reload();

                case 16:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));
        return _logout.apply(this, arguments);
      }

      if (confirm) {
        commit('d2admin/gray/set', true, {
          root: true
        });
        MessageBox.confirm('确定要注销当前用户吗', '注销用户', {
          type: 'warning'
        }).then(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          Message({
            message: '取消注销操作'
          });
        });
      } else {
        logout();
      }
    },

    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load: function load(_ref5) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var dispatch;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                dispatch = _ref5.dispatch;
                _context4.next = 3;
                return dispatch('d2admin/user/load', null, {
                  root: true
                });

              case 3:
                _context4.next = 5;
                return dispatch('d2admin/theme/load', null, {
                  root: true
                });

              case 5:
                _context4.next = 7;
                return dispatch('d2admin/page/openedLoad', null, {
                  root: true
                });

              case 7:
                _context4.next = 9;
                return dispatch('d2admin/menu/asideLoad', null, {
                  root: true
                });

              case 9:
                _context4.next = 11;
                return dispatch('d2admin/size/load', null, {
                  root: true
                });

              case 11:
                _context4.next = 13;
                return dispatch('d2admin/color/load', null, {
                  root: true
                });

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};